import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';


class Dashboard extends React.Component {

    render() {
        return (
            <div className="content-box">
                <h3>Dashboard</h3>
                <p>Welcome to Quizscape!</p>
            </div>
        );
    }
}

export default withRouter(
    connect(
        ({account: {user}}) => ({
            user,
        }),
        null
    )(Dashboard)
);
